import styled from "styled-components";
import { Paragraph2, WrapperContainer } from "../../../../components";
import { colors } from "../../../../consts";

export const TitleWrapper = styled(WrapperContainer)`
  ${Paragraph2} {
    font-weight: 600;
  }
`;

export const InfoText = styled(Paragraph2)`
  font-size: 14px;
  line-height: 24px;
  font-weight: 500 !important;
  color: ${colors.RAISIN_70};
`;
